import React, { useEffect, useState } from 'react';
import Viewer from 'react-viewer';

interface ViewerImage {
    src: string;
    alt: string;
}

export interface ImageViewerProps {
    image: ViewerImage | null;
    container: HTMLDivElement | null;
}

export function ImageViewer({ image, container }: ImageViewerProps) {
    // Retain the last image so react-viewer has valid data to render
    // during its close animation after `image` becomes null.
    const [latestImage, setLatestImage] = useState<ViewerImage | null>(null);

    useEffect(() => {
        if (!image) {
            return;
        }
        setLatestImage(image);
    }, [image]);

    if (!container || !latestImage) {
        return null;
    }

    return (
        <Viewer
            activeIndex={0}
            attribute={false}
            changeable={false}
            container={container}
            disableKeyboardSupport
            images={[latestImage]}
            loop={false}
            noClose
            noFooter
            noNavbar
            noToolbar
            visible={image !== null}
            zoomSpeed={0.2}
        />
    );
}
